import { type EventInviteeRole } from 'features/events/types';
import { type InviteTokenDataObject as InvitationTokenDataObject } from './service';

export type InvitationTokenKind = 'event_attendee_invitation' | 'event_presenter_invitation';

export class InvitationToken {
  static mapToEventRole: Record<InvitationTokenKind, EventInviteeRole | undefined> = {
    event_attendee_invitation: 'attendee',
    event_presenter_invitation: 'presenter',
  };

  token: string;
  subjectType: 'Event';
  subjectId: string;
  kind: InvitationTokenKind;

  constructor(data: InvitationTokenDataObject) {
    this.token = data.token;
    this.subjectType = data.subject_type;
    this.subjectId = data.subject_id;
    this.kind = data.kind;
  }

  get eventInviteeRole() {
    return InvitationToken.mapToEventRole[this.kind];
  }
}
